import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    marginRight: -96,
    marginLeft: -96,
    marginTop: -20,
    [theme.breakpoints.down('sm')]: {
      marginRight: -14,
      marginLeft: -15
    }
  },
  header: {
    display: 'grid',
    gridTemplateColumns: '3fr 3fr 3fr 1fr',
    gap: 24
  },
  buttons: {
    display: 'flex',
    flexDirection: 'column'
  },
  addCreditorbutton: {
    marginTop: 12
  },
  color: {
    color: theme.palette.primary.main,
    fontSize: 48
  },
  tabSection: {
    display: 'grid',
    gridTemplateColumns: '1fr 2fr',
    alignItems: 'flex-end',
    marginTop: 36,
    borderBottom: `1px solid ${theme.palette.grey[200]}`
  },
  tab: {
    fontSize: 14,
    '&.Mui-selected': {
      border: `3px solid ${theme.palette.primary.main}`,
      borderTop: 'none'
    }
  }
}))

export default useStyles
